import { type StateCreator, create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export type StoreCreatorWithMiddlewares<TState> = StateCreator<
  TState,
  [["zustand/devtools", never], ["zustand/immer", never]]
>;

export function createWithMiddlewares<TState>(
  createState: StoreCreatorWithMiddlewares<TState>,
  initialState?: TState,
  devtoolsOptions?: {
    name?: string;
    enabled?: boolean;
  },
) {
  const slice = create(
    devtools(immer(createState), devtoolsOptions || { name: "zustand-store" }),
  );
  slice.setState((state) => initialState ?? state, false, "init/store");
  return slice;
}
